var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.id)?_c('div',{attrs:{"id":"edit-puzzle"}},[_c('h2',[_vm._v("Edit\n    "),_c('router-link',{attrs:{"to":{
        name: 'puzzle',
        params: { puzzleId: _vm.puzzleId }
      }}},[_vm._v("\n      Puzzle #"+_vm._s(_vm.puzzleId)+"\n    ")])],1),_vm._v(" "),_c('puzzle-nav',{attrs:{"puzzleId":_vm.puzzleId}}),_vm._v(" "),_c('puzzle-form',{attrs:{"puzzleId":_vm.puzzleId,"puzzleUploadRequired":"false"}})],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-73fb1e02","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PuzzleEdit.vue
// module id = 1229
// module chunks = 1